import * as React from 'react';
import * as shortid from 'shortid';

interface Props {
  children: any;
}

const StaggeredList = ({ children }: Props) => (
  <div className="list">
    {children.map((child, index) => (
      <div
        className="list--item"
        style={{ animationDelay: `${index / 20}ms` }}
        key={shortid.generate()}
      >
        {child}
      </div>
    ))}
  </div>
);

export default StaggeredList;
